// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import LabeledString from '../../../../shared/components/labeled-string';
import {buildCurrency} from '../../../../shared/services/build-number';

const PercentageInfoScreen = props => {

    const newClaimValue = props.netAmountPaid - props.amountDebit;

    return (
        <div className='percentage-debit-info-panel'>
            <div className='claim-info'>
                <LabeledString
                    className='dealer-location'
                    data={buildCurrency(props.netAmountPaid)}
                    label='ORIGINAL_CLAIM_VALUE'
                />
                <LabeledString
                    className='net-amount-paid'
                    data={buildCurrency(props.amountDebit)}
                    label='AMOUNT_TO_BE_DEBITED'
                />
            </div>
            <LabeledString
                data={buildCurrency(newClaimValue)}
                label='NEW_CLAIM_VALUE'
            />
        </div>
    );

};

PercentageInfoScreen.displayName = 'PercentageInfoScreen';

PercentageInfoScreen.propTypes = {
    amountDebit: PropTypes.number.isRequired,
    netAmountPaid: PropTypes.number.isRequired

};

export default PercentageInfoScreen;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-screen/percentage-info-screen.js